export default "__VITE_ASSET__BEFmbQhe__"